import {Helmet} from "react-helmet-async";
import {
    Card,
    CardContent,
    CardHeader,
    Container,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableRow
} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import Box from "@mui/material/Box";
import {useNavigate} from "react-router-dom";
import {Add} from "@mui/icons-material";
import {config} from "../constant";
import {joinWithLastWord} from "../utils/formatString";
import DialogViewArchive from "../sections/@dashboard/archive/DialogViewArchive";
import DialogEditArchive from "../sections/@dashboard/archive/DialogEditArchive";
import DialogArchiveCategoryStats from "../sections/@dashboard/archive/DialogArchiveCategoryStats";
import UserContext from "../UserContext";
import Iconify from "../components/iconify";
import DialogArchivePersonStats from "../sections/@dashboard/archive/DialogArchivePersonStats";
import ContextMenu from "../components/context-menu";
import DialogEditArchiveCategory from "../sections/@dashboard/archive/DialogEditArchiveCategory";
import DialogEditArchivePerson from "../sections/@dashboard/archive/DialogEditArchivePerson";
import DialogGrandChampionStats from "../sections/@dashboard/archive/DialogGrandChampionStats";
import DialogRecordsByCategoriesStats from "../sections/@dashboard/archive/DialogRecordsByCategoriesStats";

export default function ArchivePage() {
    const navigate = useNavigate();

    const {user, setUser} = useContext(UserContext);
    const [archives, setArchives] = useState(null);
    const [archiveCategories, setArchiveCategories] = useState(null);
    const [archivePeople, setArchivePeople] = useState(null);
    const [archiveId, setArchiveId] = useState(null);
    const [archiveCategoryId, setArchiveCategoryId] = useState(null);
    const [archivePersonId, setArchivePersonId] = useState(null);

    const [dialogViewArchiveOpen, setDialogViewArchiveOpen] = useState(false);
    const [dialogEditArchiveOpen, setDialogEditArchiveOpen] = useState(false);
    const [dialogEditArchiveCategoryOpen, setDialogEditArchiveCategoryOpen] = useState(false);
    const [dialogArchiveCategoryStatsOpen, setDialogArchiveCategoryStatsOpen] = useState(false);
    const [dialogEditArchivePersonOpen, setDialogEditArchivePersonOpen] = useState(false);
    const [dialogArchivePersonStatsOpen, setDialogArchivePersonStatsOpen] = useState(false);
    const [dialogGrandChampionStatsOpen, setDialogGrandChampionStatsOpen] = useState(false);
    const [dialogRecordsByCategoriesStatsOpen, setDialogRecordsByCategoriesStatsOpen] = useState(false);

    const [archiveContextMenu, setArchiveContextMenu] = useState(null);
    const [categoryContextMenu, setCategoryContextMenu] = useState(null);
    const [personContextMenu, setPersonContextMenu] = useState(null);

    useEffect(() => {
        Promise.all([fetch(`${config.BASE_URL}/archives`), fetch(`${config.BASE_URL}/archive-categories`), fetch(`${config.BASE_URL}/archive-people`)])
            .then(([resArchives, resCategories, resPeople]) => Promise.all([resArchives.json(), resCategories.json(), resPeople.json()]))
            .then(([dataArchives, dataCategories, dataPeople]) => {
                setArchives(dataArchives);
                setArchiveCategories(dataCategories);
                setArchivePeople(dataPeople);
            })
            .catch((error) => {
                const message = 'Erreur dans la récupération des archives';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    }, []);

    const refreshArchives = () => {
        fetch(`${config.BASE_URL}/archives`)
            .then(response => response.json())
            .then(data => {
                setArchives(data);
            })
            .catch((error) => {
                const message = 'Erreur dans la récupération des archives';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    const refreshArchiveCategories = () => {
        fetch(`${config.BASE_URL}/archive-categories`)
            .then(resCategories => resCategories.json())
            .then(dataCategories => {
                setArchiveCategories(dataCategories);
            })
            .catch((error) => {
                const message = 'Erreur dans la récupération des catégories archives';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    const refreshArchivePeople = () => {
        fetch(`${config.BASE_URL}/archive-people`)
            .then(resPeople => resPeople.json())
            .then(dataPeople => {
                setArchivePeople(dataPeople);
            })
            .catch((error) => {
                const message = 'Erreur dans la récupération des personnes archives';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    const handleOpenArchive = (archiveId) => {
        setArchiveId(archiveId);
        if (user && user.isAdmin) {
            setDialogEditArchiveOpen(true);
        } else {
            setDialogViewArchiveOpen(true);
        }
    };

    const handleOpenArchiveCategoryStats = (archiveCategoryId) => {
        setArchiveCategoryId(archiveCategoryId);
        setDialogArchiveCategoryStatsOpen(true);
    };

    const handleOpenArchivePersonStats = (archivePersonId) => {
        setArchivePersonId(archivePersonId);
        setDialogArchivePersonStatsOpen(true);
    };

    // ===== Gestion du menu contextuel

    const handleOpenArchiveMenu = (event, archiveId) => {
        setArchiveId(archiveId);
        setArchiveContextMenu(event.currentTarget);
    };

    const handleEditArchive = (archiveId) => {
        setArchiveContextMenu(null);
        handleOpenArchive(archiveId);
    };

    const handleDeleteArchive = () => {
        const requestOptions = {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' }
        };
        fetch(`${config.BASE_URL}/archives/${archiveId}`, requestOptions)
            .then(response => {
                setArchiveId(null);
                refreshArchives();
            })
            .catch((error) => {
                const message = 'Erreur dans la suppression d\'une archive';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    const handleOpenCategoryMenu = (event, archiveCategoryId) => {
        setArchiveCategoryId(archiveCategoryId);
        setCategoryContextMenu(event.currentTarget);
    };

    const handleDeleteCategory = () => {
        const requestOptions = {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' }
        };
        fetch(`${config.BASE_URL}/archive-categories/${archiveCategoryId}`, requestOptions)
            .then(response => {
                setArchiveCategoryId(null);
                refreshArchiveCategories();
            })
            .catch((error) => {
                const message = 'Erreur dans la suppression d\'une catégorie archive';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    const handleOpenPersonMenu = (event, archivePersonId) => {
        setArchivePersonId(archivePersonId);
        setPersonContextMenu(event.currentTarget);
    };

    const handleDeletePerson = () => {
        const requestOptions = {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' }
        };
        fetch(`${config.BASE_URL}/archive-people/${archivePersonId}`, requestOptions)
            .then(response => {
                setArchivePersonId(null);
                refreshArchivePeople();
            })
            .catch((error) => {
                const message = 'Erreur dans la suppression d\'une personne archive';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    // ===== Fin gestion du menu contextuel =====

    const handleAddArchive = () => {
        setArchiveId(null);
        setDialogEditArchiveOpen(true);
    };

    const handleAddArchivePerson = () => {
        setArchivePersonId(null);
        setDialogEditArchivePersonOpen(true);
    };

    const handleAddArchiveCategory = () => {
        setArchiveCategoryId(null);
        setDialogEditArchiveCategoryOpen(true);
    };

    const handleCloseDialogEditArchive = (refresh) => {
        setDialogEditArchiveOpen(false);
        if (refresh) {
            refreshArchives();
        }
    };

    const handleCloseDialogEditArchiveCategory = (refresh) => {
        setDialogEditArchiveCategoryOpen(false);
        if (refresh) {
            refreshArchiveCategories();
        }
    };

    const handleCloseDialogEditArchivePerson = (refresh) => {
        setDialogEditArchivePersonOpen(false);
        if (refresh) {
            refreshArchivePeople();
        }
    };

    return (
        <>
            <Helmet>
                <title>Archives | Lose Awards</title>
            </Helmet>

            {archives && archiveCategories && archivePeople && (
                <Container maxWidth="false">
                    <Grid container spacing={3}>
                        {/*Archives*/}
                        <Grid item xs={12} md={4} lg={4}>
                            <Card>
                                {(user && user.isAdmin) ? (
                                    <>
                                        <CardHeader title="Archives" action={<IconButton onClick={handleAddArchive}><Add /></IconButton>} />
                                        <CardContent>
                                            <Table>
                                                <TableBody>
                                                    {archives.map(archive => (
                                                        <TableRow hover key={archive.id}>
                                                            <TableCell padding="none" align="left">
                                                                {archive.year} ({joinWithLastWord(archive.archiveRanks[0].people.map(person => person.firstName), ', ', 'et')})
                                                            </TableCell>
                                                            <TableCell padding="none" align="right">
                                                                <IconButton size="large" color="inherit" onClick={(event) => handleOpenArchiveMenu(event, archive.id)}>
                                                                    <Iconify icon={'eva:more-vertical-fill'} />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </CardContent>
                                    </>
                                ) : (
                                    <>
                                        <CardHeader title="Archives" />
                                        <CardContent>
                                            {archives.map(archive => (
                                                <Box onClick={() => handleEditArchive(archive.id)} key={archive.id} sx={{cursor: 'pointer', mb: 1}}>
                                                    {archive.year} ({joinWithLastWord(archive.archiveRanks[0].people.map(person => person.firstName), ', ', 'et')})
                                                </Box>
                                            ))}
                                        </CardContent>
                                    </>
                                )}
                            </Card>
                        </Grid>

                        {/*Catégories archive*/}
                        <Grid item xs={12} md={4} lg={4}>
                            <Card>
                                {(user && user.isAdmin) ? (
                                    <>
                                        <CardHeader title="Statistiques par catégorie" action={<IconButton onClick={handleAddArchiveCategory}><Add /></IconButton>} />
                                        <CardContent>
                                            <Table>
                                                <TableBody>
                                                    <TableRow hover sx={{cursor: 'pointer'}}>
                                                        <TableCell padding="none" align="left" onClick={() => setDialogRecordsByCategoriesStatsOpen(true)} sx={{paddingTop: 1.2, paddingBottom: 1.2}}>
                                                            <b>Records par catégorie</b>
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow hover sx={{cursor: 'pointer'}}>
                                                        <TableCell padding="none" align="left" onClick={() => setDialogGrandChampionStatsOpen(true)} sx={{paddingTop: 1.2, paddingBottom: 1.2}}>
                                                            <b>Grand Champion</b>
                                                        </TableCell>
                                                    </TableRow>
                                                    {archiveCategories.map(archiveCategory => (
                                                        <TableRow hover key={archiveCategory.id}>
                                                            <TableCell padding="none" align="left">
                                                                {archiveCategory.name}
                                                            </TableCell>
                                                            <TableCell padding="none" align="right">
                                                                <IconButton size="large" color="inherit" onClick={(event) => handleOpenCategoryMenu(event, archiveCategory.id)}>
                                                                    <Iconify icon={'eva:more-vertical-fill'} />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </CardContent>
                                    </>
                                ) : (
                                    <>
                                        <CardHeader title="Statistiques par catégorie" />
                                        <CardContent>
                                            <Box onClick={() => setDialogRecordsByCategoriesStatsOpen(true)} sx={{cursor: 'pointer', mb: 1}}>
                                                <b>Records par catégorie</b>
                                            </Box>
                                            <Box onClick={() => setDialogGrandChampionStatsOpen(true)} sx={{cursor: 'pointer', mb: 1}}>
                                                <b>Grand Champion</b>
                                            </Box>
                                            {archiveCategories.map(archiveCategory => (
                                                <Box onClick={() => handleOpenArchiveCategoryStats(archiveCategory.id)} key={archiveCategory.id} sx={{cursor: 'pointer', mb: 1}}>
                                                    {archiveCategory.name}
                                                </Box>
                                            ))}
                                        </CardContent>
                                    </>
                                )}
                            </Card>
                        </Grid>

                        {/*Personnes archive*/}
                        <Grid item xs={12} md={4} lg={4}>
                            <Card>
                                {(user && user.isAdmin) ? (
                                    <>
                                        <CardHeader title="Statistiques par compétiteur" action={<IconButton onClick={handleAddArchivePerson}><Add /></IconButton>} />
                                        <CardContent>
                                            <Table>
                                                <TableBody>
                                                    {archivePeople.map(archivePerson => (
                                                        <TableRow hover key={archivePerson.id}>
                                                            <TableCell padding="none" align="left">
                                                                {archivePerson.firstName}
                                                            </TableCell>
                                                            <TableCell padding="none" align="right">
                                                                <IconButton size="large" color="inherit" onClick={(event) => handleOpenPersonMenu(event, archivePerson.id)}>
                                                                    <Iconify icon={'eva:more-vertical-fill'} />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </CardContent>
                                    </>
                                ) : (
                                    <>
                                        <CardHeader title="Statistiques par compétiteur" />
                                        <CardContent>
                                            {archivePeople.map(archivePerson => (
                                                <Box onClick={() => handleOpenArchivePersonStats(archivePerson.id)} key={archivePerson.id} sx={{cursor: 'pointer', mb: 1}}>
                                                    {archivePerson.firstName}
                                                </Box>
                                            ))}
                                        </CardContent>
                                    </>
                                )}
                            </Card>
                        </Grid>
                    </Grid>
                </Container>
            )}

            {dialogViewArchiveOpen && (
                <DialogViewArchive open={dialogViewArchiveOpen} onClose={() => setDialogViewArchiveOpen(false)} archiveId={archiveId}>
                </DialogViewArchive>
            )}

            {dialogEditArchiveOpen && (
                <DialogEditArchive open={dialogEditArchiveOpen} onClose={handleCloseDialogEditArchive} archiveId={archiveId} archiveCategories={archiveCategories} archivePeople={archivePeople}>
                </DialogEditArchive>
            )}

            {dialogEditArchiveCategoryOpen && (
                <DialogEditArchiveCategory open={dialogEditArchiveCategoryOpen} onClose={handleCloseDialogEditArchiveCategory} archiveCategoryId={archiveCategoryId}>
                </DialogEditArchiveCategory>
            )}

            {dialogArchiveCategoryStatsOpen && (
                <DialogArchiveCategoryStats open={dialogArchiveCategoryStatsOpen} onClose={() => setDialogArchiveCategoryStatsOpen(false)} archiveCategoryId={archiveCategoryId}>
                </DialogArchiveCategoryStats>
            )}

            {dialogEditArchivePersonOpen && (
                <DialogEditArchivePerson open={dialogEditArchivePersonOpen} onClose={handleCloseDialogEditArchivePerson} archivePersonId={archivePersonId}>
                </DialogEditArchivePerson>
            )}

            {dialogArchivePersonStatsOpen && (
                <DialogArchivePersonStats open={dialogArchivePersonStatsOpen} onClose={() => setDialogArchivePersonStatsOpen(false)} archivePersonId={archivePersonId}>
                </DialogArchivePersonStats>
            )}

            {dialogGrandChampionStatsOpen && (
                <DialogGrandChampionStats open={dialogGrandChampionStatsOpen} onClose={() => setDialogGrandChampionStatsOpen(false)}>
                </DialogGrandChampionStats>
            )}

            {dialogRecordsByCategoriesStatsOpen && (
                <DialogRecordsByCategoriesStats open={dialogRecordsByCategoriesStatsOpen} onClose={() => setDialogRecordsByCategoriesStatsOpen(false)}>
                </DialogRecordsByCategoriesStats>
            )}

            <ContextMenu
                target={archiveContextMenu}
                setTarget={setArchiveContextMenu}
                handleEdit={() => {
                    handleOpenArchive(archiveId);
                }}
                handleDelete={handleDeleteArchive}
            >
            </ContextMenu>

            <ContextMenu
                target={categoryContextMenu}
                setTarget={setCategoryContextMenu}
                handleEdit={() => {
                    setDialogEditArchiveCategoryOpen(true);
                }}
                handleDelete={handleDeleteCategory}
                handleStats={() => {
                    handleOpenArchiveCategoryStats(archiveCategoryId);
                }}
            >
            </ContextMenu>

            <ContextMenu
                target={personContextMenu}
                setTarget={setPersonContextMenu}
                handleEdit={() => {
                    setDialogEditArchivePersonOpen(true);
                }}
                handleDelete={handleDeletePerson}
                handleStats={() => {
                    setDialogArchivePersonStatsOpen(true);
                }}
            >
            </ContextMenu>
        </>
    );
}